import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from '../AccentedSvgIcon';
import Twitter from '@material-ui/icons/Twitter';

export const TwitterIcon = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} className="ue-icon-twitter">
        <Twitter />
    </AccentedSvgIcon>
);
